module.exports = __webpack_public_path__ + "img/Erwin_logo.7fa6a2b7.png";